module.exports = __webpack_public_path__ + "img/brand1.b8b6cb87.png";